import { Component, OnInit } from '@angular/core';
import { SeriesLabelsVisualArgs } from '@progress/kendo-angular-charts';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { CommonService } from 'src/app/Service/Common.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public pfaDataList:Array<any> = [];
  public pfaGridDataList:Array<any> = [];
  public enableFilter = false;
  public enableFullscreen = false;
  public categorieList:Array<any> =[];
  public totalName:string;
  overallEnable = false;
  coursesEnable:boolean = false;
  isDataLoaded: number = 0;
  public pageSize = 20;
  public pageSizes = [20, 40, 60, 80, 100];
  public dashboardDetails:Array<any>=[];


  constructor(private _peerReviewService:PeerReviewService,private _commonServices:CommonService) {
    this.excelData = this.excelData.bind(this);
   }

   public excelData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.pfaGridDataList
    };
    return result;
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }


  ngOnInit(): void {
   this.initialDataLoad();

  }

  initialDataLoad(){
    const input = {intUID : this._commonServices.getLoggedInUserId()}
    this._peerReviewService.getPRDashboard(input).subscribe((res:any)=>{
      this.isDataLoaded == 1;
      this.pfaGridDataList=res.prDashboardDetailsOutputModel;
      this.pfaDataList = res.prDashboardSummaryOutputModel;
    });
    this.categorieList = this.pfaDataList.map(item => item.division);
    var total =  this.pfaDataList.reduce((total, item) => total + item.no_of_Reviews, 0);
    this.totalName = "Total PAF - "+total+" Nos.completed"
  }

  public labelVisual(args: SeriesLabelsVisualArgs): Element {
    const label: any = args.createVisual();
    label.options.set('cursor', 'pointer');
    return label;
  }

  getpfaGridData(){
    return [
      {projectBrief:"O21566-TC4 Building, HQ Chennai",sgmtHead:"REN",peerReviewDate:"03-04-2022",totalComments:"48",l1:"13",l3:"32",l2:"3",PRStatus:"P",ImplactStatus:"P"},
      {projectBrief:"T22326 - Medical College & Hospital Campus at Bongaigaon & Golaghat",sgmtHead:"JA",peerReviewDate:"06-06-2022",totalComments:"48",l1:"15",l3:"16",l2:"17",PRStatus:"Arch pending",ImplactStatus:"x"},
      {projectBrief:"T22082 - Redevelopment of Assam Police Reserve Campus Guwahati",sgmtHead:"CKSR",peerReviewDate:"21-06-2022",totalComments:"51",l1:"25",l3:"16",l2:"10",PRStatus:"P",ImplactStatus:"P"},
      {projectBrief:"T22447 - Construction of 1000 bed Super Specialty Hospital, TIMS Hyderabad",sgmtHead:"CKSR",peerReviewDate:"07-09-2022",totalComments:"45",l1:"10",l3:"29",l2:"06",PRStatus:"P",ImplactStatus:"P"},
      {projectBrief:"T22478-Proposed commercial building BKC Mumbai",sgmtHead:"REN",peerReviewDate:"01-11-2022",totalComments:"103",l1:"16",l3:"31",l2:"12",PRStatus:"P",ImplactStatus:"x"}
    ]
  }

  getpfaData(){
    return [
      {
          "division": "HEALTH",
          "reviews": 1
      },
      {
          "division": "ITOS",
          "reviews": 2
      },
      {
          "division": "DATACENTER",
          "reviews": 0
      },
      {
          "division": "RESIDENTIAL",
          "reviews": 2
      }
  ]
  }

  toggleFullscreen(chart: string) {
    if(chart == 'overallEnable'){
      this.overallEnable = !this.overallEnable;
    } 
  }

}
